var _g, _g2, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKocumYanimdaApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 255,
    viewBox: "0 0 97 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1686_719)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 65,
    width: 30,
    height: 30,
    rx: 9,
    fill: "url(#paint0_radial_1686_719)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_1686_719)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 86,
    r: 6,
    fill: "#0D4970"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.08
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 74C34 69.0294 38.0294 65 43 65H55C59.9705 65 64 69.0294 64 74V86C64 90.9706 59.9705 95 55 95H43C38.0294 95 34 90.9706 34 86V74Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5306 79.6592L49.6212 72.9368C49.2358 72.65 48.707 72.65 48.3215 72.9368L39.4122 79.6592C38.8385 80.0894 38.8385 80.9409 39.4122 81.3711L48.3215 88.0935C48.707 88.3803 49.2358 88.3803 49.6212 88.0935L56.3397 83.0242V83.9316L55.2103 84.7831C55.0669 84.8906 55.0669 85.1147 55.2103 85.2223L56.3397 86.0738V86.5399C56.3397 86.7012 56.4652 86.8267 56.6265 86.8267H56.6623C56.8237 86.8267 56.9492 86.7012 56.9492 86.5399V86.0469L58.0337 85.2223C58.1771 85.1237 58.1771 84.8996 58.0337 84.792L56.9492 83.9674V82.5644L58.5306 81.3711C59.1042 80.9409 59.1042 80.0894 58.5306 79.6592ZM52.6196 81.108L49.4002 83.5316C49.1462 83.7203 48.7977 83.7203 48.5437 83.5316L48.1951 83.2663C48.1302 83.2191 48.0475 83.2073 47.9707 83.2427L46.8424 83.7616C46.6652 83.8441 46.5825 83.7675 46.6652 83.5847L47.0964 82.653C47.1378 82.5586 47.1141 82.4466 47.0314 82.3876L45.3302 81.1021C44.9521 80.8191 44.9521 80.2589 45.3302 79.9759L48.5496 77.5523C48.8036 77.3636 49.1521 77.3636 49.4061 77.5523L52.6255 79.9759C52.9917 80.2648 52.9917 80.825 52.6196 81.108ZM56.9492 85.4284L57.3525 85.1237C57.4242 85.0699 57.4242 84.9534 57.3525 84.8996L56.9492 84.5949L56.7072 84.4156C56.6534 84.3797 56.5906 84.3797 56.5369 84.4156L56.3397 84.568L55.8915 84.8996C55.8198 84.9534 55.8198 85.0699 55.8915 85.1237L56.3397 85.4553L56.5369 85.6077C56.5906 85.6435 56.6534 85.6435 56.7072 85.6077L56.9492 85.4284Z",
    fill: "#1F6A9C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5306 78.685L49.6212 71.9627C49.2358 71.6759 48.707 71.6759 48.3215 71.9627L39.4122 78.685C38.8385 79.1153 38.8385 79.9668 39.4122 80.397L48.3215 87.1194C48.707 87.4062 49.2358 87.4062 49.6212 87.1194L56.3397 82.0501V83.5419L55.2103 84.3934C55.0669 84.501 55.0669 84.7251 55.2103 84.8326L56.3397 85.6841V86.1502C56.3397 86.3115 56.4652 86.437 56.6265 86.437H56.6624C56.8237 86.437 56.9492 86.3115 56.9492 86.1502V85.6572L58.0337 84.8326C58.1771 84.734 58.1771 84.5099 58.0337 84.4024L56.9492 83.5778V81.5902L58.5306 80.397C59.1042 79.9668 59.1042 79.1153 58.5306 78.685ZM52.6196 80.1339L49.4002 82.5574C49.1462 82.7461 48.7977 82.7461 48.5437 82.5574L48.1952 82.2921C48.1302 82.2449 48.0475 82.2331 47.9707 82.2685L46.8424 82.7874C46.6652 82.87 46.5825 82.7933 46.6652 82.6105L47.0964 81.6788C47.1378 81.5845 47.1142 81.4724 47.0315 81.4135L45.3302 80.128C44.9521 79.8449 44.9521 79.2847 45.3302 79.0017L48.5496 76.5781C48.8036 76.3894 49.1521 76.3894 49.4061 76.5781L52.6255 79.0017C52.9917 79.2906 52.9917 79.8508 52.6196 80.1339ZM56.9492 85.0388L57.3525 84.734C57.4242 84.6802 57.4242 84.5637 57.3525 84.5099L56.9492 84.2052L56.7072 84.0259C56.6534 83.9901 56.5907 83.9901 56.5369 84.0259L56.3397 84.1783L55.8915 84.5099C55.8198 84.5637 55.8198 84.6802 55.8915 84.734L56.3397 85.0657L56.5369 85.218C56.5907 85.2539 56.6534 85.2539 56.7072 85.218L56.9492 85.0388Z",
    fill: "#F0F0F0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1686_719",
    x: -66,
    y: 25,
    width: 230,
    height: 230,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 60
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1686_719"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1686_719",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1686_719",
    x: -37,
    y: 0,
    width: 172,
    height: 172,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40,
    result: "effect1_foregroundBlur_1686_719"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1686_719",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.5915 69.0512) scale(19.5581)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DB1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2073AA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKocumYanimdaApp);
export default __webpack_public_path__ + "static/media/kocum-yanimda-app.4e6beacf186e1ec6dc7cce17fa1b86fc.svg";
export { ForwardRef as ReactComponent };